import { CircularProgress, Grid, Typography } from '@material-ui/core';
import InfiniteScroll from 'react-infinite-scroll-component';
import ActivityCard from './ideaCard';
import './style.css';

import { makeStyles } from '@material-ui/styles';
import ideaList from 'assets/image/ideation/idea_list_in_convocation.png';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
	activitiesContainer: {
		marginTop: 30,
		userSelect: 'none',
		position: 'relative',
		// marginBottom: 100,
		[theme.breakpoints.down('sm')]: {
			width: '100%',
		},
	},
}));
export default function InfiniteScrollComponent({ data, hasMore, fetchData, border, section }) {
	const classes = useStyles();
	const currentUserSlug = useSelector((state) => state?.main?.currentUser?.slug);
	// useEffect(() => {
	//     const slug = localStorage.getItem("activitySlug");
	//     const scroll = document.querySelector(`#activity-card-${slug}`)?.offsetTop;
	//      const infinite=document.querySelector(`#infinite-scroll`)?.style="opacity:0;"
	//      console.log(scroll);
	//      if (scroll) window.scrollTo(0, scroll);
	//      setTimeout(() => {
	//          localStorage.removeItem("activitySlug");
	//         }, 400);
	// }, [data]);
	// useEffect(() => {
	//     const slug = localStorage.getItem("activitySlug");
	//     const scroll = document.querySelector(`#activity-card-${slug}`)?.offsetTop;
	//     console.log(scroll);
	//     if (scroll) window.scrollTo(0, scroll);
	//     setTimeout(() => {
	//         document.querySelector(`#infinite-scroll`)?.style="opacity:1;";
	//         localStorage.removeItem("activitySlug");
	//        }, 400);
	// }, []);

	return (
		<Grid container justify="center" id="infinite-scroll" className={classes.activitiesContainer}>
			<Grid container>
				<InfiniteScroll
					dataLength={data?.length || 0} //This is important field to render the next data
					next={fetchData}
					hasMore={hasMore}
					// scrollThreshold="80%"
					loader={
						<Grid
							container
							item
							md={12}
							justify="center"
							style={{ height: 50, position: 'absolute', bottom: -50 }}
						>
							<CircularProgress style={{ color: '#1096db' }} />
						</Grid>
					}
					style={{
						width: '100%',
						display: 'grid',
						flexWrap: 'wrap',
						gap: 15,
						gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
						padding: '15px',
						backgroundImage: `url(${ideaList})`,
						backgroundSize: 'contain',
						backgroundPosition: 'center',
						backgroundRepeat: 'repeat-y',
					}}
				>
					{data &&
						data?.map((item, index) => {
							return (
								<Grid item key={item.id} container justify="center" style={{ maxWidth: '100%' }}>
									<ActivityCard item={item} currentUserSlug={currentUserSlug} />
								</Grid>
							);
						})}
				</InfiniteScroll>
				{!!data && data?.length === 0 ? <Typography variant="h4">ایده‌ای وجود ندارد</Typography> : null}
			</Grid>
		</Grid>
	);
}
